import { Injectable } from '@angular/core';
import { getProperty, isInArrayKey, encodeUtf8, checkBoolean } from '@core/_utils/tools.utils';
import { formatDateTimeInternal } from '@core/_utils/date.utils';
import { EditorService } from './editor.service';

@Injectable()
export class DockStandardService {
    private edtAllUser: any;
    private enableDeadline = false;
    private defValue = '';
    private defValueSto = '';
    private defValueInd = '';
    private datVal = '';
    private deadline = '';
    public destList: any;
    public destTmp: Array<Object>;

    constructor(public editorService: EditorService) {
        this.edtAllUser = new Array();
        this.destList = new Array();
        this.destTmp = new Array();
    }

    public getParamDock(aTypeDock, aName, aVarList) {
        let wParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        let wTypeBsk;

        switch (aTypeDock) {
            case 'InvoiceValidation': {
                wTypeBsk = this.getTypeBskDock(aName);
                switch (wTypeBsk) {
                    case 'IIA_InvoiceIndexing': {
                        // Indexation des factures :
                        // Indexeur, Valideur, Date de validation, Controller, Date limite
                        this.initDefaultValueInvoice(aVarList);
                        wParamDock = this.setInvoiceIndexing();
                        break;
                    }
                    case 'IIA_InvoiceValidation': {
                        // Validation des factures
                        // Indexeur, Valideur, Date de validation, Controller, Date limite
                        this.initDefaultValueInvoice(aVarList);
                        wParamDock = this.setInvoiceValidation(aName);
                        break;
                    }
                    case 'IIA_InvoiceDispute': {
                        // Factures en litige
                        // Indexeur, Valideur, Date de validation, Controller, Date limite
                        this.initDefaultValueInvoice(aVarList);
                        wParamDock = this.setInvoiceDispute(aName);
                        break;
                    }
                    case 'IIA_InvoiceFinal': {
                        // Paiement dees factures
                        // Indexeur, Valideur, Date de validation, Controller, Date limite
                        this.initDefaultValueInvoice(aVarList);
                        wParamDock = this.setInvoiceFinal(aName);
                        break;
                    }
                }
                break;
            }
            case 'MailDispatching': {
                this.initDefaultValueMail(aVarList);
                wParamDock = this.setMailDispatching();
                break;
            }
            case 'MailValidation': {
                this.initDefaultValueMailValidation(aVarList);
                wParamDock = this.setMailValidation();
                break;
            }
            case 'MailReordering': {
                break;
            }
        }
        return wParamDock;
    }

    private initDefaultValue() {
        this.enableDeadline = false;
        this.defValue = '';
        this.defValueSto = '';
        this.defValueInd = '';
        this.datVal = '';
        this.deadline = '';
        this.edtAllUser = [];
        this.destList = [];
        this.edtAllUser = this.editorService.getOptionComboValueData('EDT_AllUsers');
    }

    private initDefaultValueMail(aVarList) {
        let wVal: any;
        let wParser = new DOMParser();
        let wxmlDoc: any;

        this.initDefaultValue();

        // Lecture des valeurs par default
        wVal = getProperty(aVarList, '__Deadline');
        if (wVal !== undefined) {
            this.deadline = wVal;
            this.enableDeadline = true;
        }

        wVal = getProperty(aVarList, 'sys_MailRecipient');
        if (wVal !== undefined) {
            wxmlDoc = wParser.parseFromString(wVal, 'text/xml');
            //Récup stockage
            this.defValueSto = this.getStorage(wxmlDoc);

            //Récup utilisateurs
            this.destList = this.getDestList(wxmlDoc);
        }
    }

    private initDefaultValueMailValidation(aVarList) {
        let wVal: any;
        let wParser = new DOMParser();
        let wxmlDoc: any;

        this.initDefaultValue();

        // Lecture des valeurs par default
        wVal = getProperty(aVarList, 'sys_Dockproperties');
        if (wVal !== undefined) {
            wxmlDoc = wParser.parseFromString(wVal, 'text/xml');
            this.enableDeadline = wxmlDoc.getElementsByTagName('enabledeadline')[0].childNodes[0].nodeValue;
        }

        // Lecture des valeurs par default
        wVal = getProperty(aVarList, '__Deadline');
        if (wVal !== undefined) {
            this.deadline = wVal;
            this.enableDeadline = true;
        }

        wVal = getProperty(aVarList, 'sys_validator');
        if (wVal !== undefined) {
            this.defValue = wVal;
        }

        wVal = getProperty(aVarList, '__Department');
        if (wVal !== undefined) {
            this.defValueSto = wVal;
        }
    }

    private getStorage(aXmlDoc) {
        let wNodes: any;
        let wRes = '';
        wNodes = aXmlDoc.evaluate('/mailinfo/storage/name', aXmlDoc, null, XPathResult.STRING_TYPE, null);
        wRes = this.getXmlData(wNodes);
        return wRes;
    }

    private getDestList(aXmlDoc) {
        let wNodes: any;
        let wChildNode: any;
        let wRecipient: any;
        let wInfosMail: any;
        let wDestArray: any;
        let wName = '';
        wDestArray = new Array();
        wNodes = aXmlDoc.evaluate(
            '/mailinfo/recipientlist/recipient',
            aXmlDoc,
            null,
            XPathResult.UNORDERED_NODE_ITERATOR_TYPE,
            null
        );
        wRecipient = wNodes.iterateNext();
        while (wRecipient) {
            // wText = result.childNodes[0].textContent; // ok
            wInfosMail = new Object();
            wChildNode = aXmlDoc.evaluate('./name', wRecipient, null, XPathResult.STRING_TYPE, null);
            wName = this.getXmlData(wChildNode);
            if (wName.trim() !== '') {
                wInfosMail.retCode = wName;

                wChildNode = aXmlDoc.evaluate('./action', wRecipient, null, XPathResult.STRING_TYPE, null);
                wInfosMail.action = this.getXmlData(wChildNode);

                wChildNode = aXmlDoc.evaluate('./urgent', wRecipient, null, XPathResult.STRING_TYPE, null);
                wInfosMail.urgent = this.getXmlData(wChildNode);

                wChildNode = aXmlDoc.evaluate('./confidential', wRecipient, null, XPathResult.STRING_TYPE, null);
                wInfosMail.confidential = this.getXmlData(wChildNode);

                wChildNode = aXmlDoc.evaluate('./status', wRecipient, null, XPathResult.STRING_TYPE, null);
                wInfosMail.status = this.getXmlData(wChildNode);
                wDestArray.push(wInfosMail);
            }
            wRecipient = wNodes.iterateNext();
        }
        return wDestArray;
    }

    private getXmlData(aChildNode) {
        let wRes = '';
        if (aChildNode) {
            wRes = aChildNode.stringValue;
        }
        return wRes;
    }

    private setMailDispatching() {
        let wParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        let wParam: any;
        let wComboValue: any;
        let wTrgList: any;
        let wSrcList: any;
        let wResult: any;
        let wValue: any;
        let wCombo_value = {
            comboValue: [],
            value: '',
        };
        wParam = new Array();
        wComboValue = new Array();
        wSrcList = new Array();
        wTrgList = new Array();
        this.destTmp = [];

        // Bannette de distribution courrier
        // Classement, date limite, liste utilisateurs, liste destinataires
        // Combo services
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_Services');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueSto, wComboValue, 'retCode');
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };

        this.setParam(
            wParam,
            '__Department',
            'Classement',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueSto,
            wCombo_value.value,
            true,
            true
        );

        // Date de limite
        this.addDate(wParam, '__Deadline', 'Date limite', 'DateTime', this.deadline, this.enableDeadline, false);

        // Utilisateurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_MailingLists');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_ServiceMailRecipients');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_UserMailRecipients');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);

        wSrcList = this.updateSrcList(wComboValue, this.destList, 'retCode');
        wTrgList = this.updateTrgList(wComboValue, wSrcList, 'retCode');

        wParamDock.varList = JSON.parse(JSON.stringify(wParam));
        wParamDock.srcList = JSON.parse(JSON.stringify(wSrcList));
        wParamDock.trgList = JSON.parse(JSON.stringify(wTrgList));

        return wParamDock;
    }

    private setMailValidation() {
        let wParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        let wParam: any;
        let wComboValue: any;
        let wResult: any;
        let wValue: any;
        let wCombo_value = {
            comboValue: [],
            value: '',
        };
        wParam = new Array();
        wComboValue = new Array();
        this.destTmp = [];

        // Bannette de validation courrier
        // Valideurs, classement, date limite

        // Combo valideurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_MailAuto');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_MailValidators');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValue, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        this.setParam(
            wParam,
            'sys_validator',
            'Valideurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValue,
            wCombo_value.value,
            true,
            true
        );

        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_Services');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueSto, wComboValue, 'retCode');
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };

        this.setParam(
            wParam,
            '__Department',
            'Classement',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueSto,
            wCombo_value.value,
            true,
            true
        );

        // Date de limite
        this.addDate(wParam, '__Deadline', 'Date limite', 'DateTime', this.deadline, this.enableDeadline, false);

        wParamDock.varList = JSON.parse(JSON.stringify(wParam));

        return wParamDock;
    }

    private updateComboValue(aSrcCombo, adata) {
        let wCombo: any;
        for (let i = 0; i < adata.show.length; i++) {
            if (adata.show[i] !== '') {
                wCombo = new Object();
                wCombo = {
                    displayValue: adata.show[i],
                    retCode: adata.value[i],
                };
                aSrcCombo.push(wCombo);
            }
        }
        return aSrcCombo;
    }

    private updateSrcList(aSrcList, aDstList, aKey) {
        let wArray = [];
        let wRes;
        aSrcList.forEach((itemSrc) => {
            wRes = isInArrayKey(itemSrc.retCode, aDstList, aKey);
            if (wRes === undefined) {
                wArray.push(itemSrc);
            }
        });
        return wArray;
    }

    private updateTrgList(aSrcList, aDstList, aKey) {
        let wArray = [];
        let wRes;
        let wData: any;
        aSrcList.forEach((itemSrc) => {
            wRes = isInArrayKey(itemSrc.retCode, aDstList, aKey);
            if (wRes === undefined) {
                wData = this.setInfosMail(itemSrc);
                wArray.push(wData);
            }
        });
        return wArray;
    }

    private setInfosMail(aItemSrc) {
        let wData: any;
        let wInfoMail;
        wData = this.addInfosMail(aItemSrc, wInfoMail);
        return wData;
    }

    public addDestList(aInfosMail) {
        let wData: any;
        this.destTmp.map((item) => {
            wData = this.addInfosMail(item, aInfosMail);
            this.destList.push(wData);
        });
    }

    public updateDestList(aItems) {
        for (const item of aItems) {
            this.destList = this.destList.filter((elem) => {
                return item.retCode !== elem.retCode;
            });
        }
    }

    private addInfosMail(aItem, aInfosMail) {
        let wData: any;
        wData = new Object();
        wData.displayValue = '';
        wData.retCode = '';
        wData.action = '0';
        wData.urgent = 'false';
        wData.confidential = 'false';
        wData.status = '';
        wData.displayValue = aItem.displayValue;
        wData.retCode = aItem.retCode;
        if (aInfosMail !== undefined) {
            wData.action = aInfosMail.mailAction;
            wData.urgent = aInfosMail.mailUrgent ? 'true' : 'false';
            wData.confidential = aInfosMail.mailConf ? 'true' : 'false';
            wData.status = aInfosMail.status;
        }
        return wData;
    }

    public getRecipientList(aVarList) {
        let wValue = '';
        let wVariable: any;
        wValue = this.generateRecipientList(aVarList);
        wVariable = new Object();
        wVariable.name = 'sys_MailRecipient';
        wVariable.type = 'String';
        wVariable.value = wValue;
        aVarList.push(wVariable);
    }

    private generateRecipientList(aVarList) {
        let wXmlDoc: any;
        let wNewElement: any;
        let wElementrecipientlist: any;
        let wRecipient: any;
        let wValue = '';
        let serializer = new XMLSerializer();
        wXmlDoc = document.implementation.createDocument('', 'mailinfo', null);

        wNewElement = wXmlDoc.createElement('storage');
        wValue = this.editorService.getVariableValue(aVarList, '__Department');
        wNewElement.appendChild(this.addNode(wXmlDoc, wNewElement, 'name', wValue));
        wXmlDoc.documentElement.appendChild(wNewElement);

        wElementrecipientlist = wXmlDoc.createElement('recipientlist');

        for (const item of this.destList) {
            wNewElement = wXmlDoc.createElement('recipient');
            wRecipient = this.createRecipient(wXmlDoc, wNewElement, item);
            wElementrecipientlist.appendChild(wRecipient);
        }

        wXmlDoc.documentElement.appendChild(wElementrecipientlist);

        wValue = '<?xml version="1.0" encoding="UTF-8"?>' + serializer.serializeToString(wXmlDoc);
        return wValue;
    }

    private createRecipient(aXmlDoc, aNewElement, item) {
        aNewElement.appendChild(this.addNode(aXmlDoc, aNewElement, 'name', item.retCode));
        aNewElement.appendChild(this.addNode(aXmlDoc, aNewElement, 'action', item.action));
        aNewElement.appendChild(this.addNode(aXmlDoc, aNewElement, 'urgent', item.urgent));
        aNewElement.appendChild(this.addNode(aXmlDoc, aNewElement, 'confidential', item.confidential));
        aNewElement.appendChild(this.addNode(aXmlDoc, aNewElement, 'status', encodeUtf8(item.status)));
        return aNewElement;
    }

    private addNode(aXmlDoc, aNode, aNodeName, aNodeValue) {
        let newElementName = aXmlDoc.createElement(aNodeName);
        aNode.appendChild(newElementName);
        let newText = aXmlDoc.createTextNode(aNodeValue);
        newElementName.appendChild(newText);
        return newElementName;
    }

    private initDefaultValueInvoice(aVarList) {
        let wVal: any;
        let wParser = new DOMParser();
        let wxmlDoc: any;

        this.initDefaultValue();

        // Lecture des valeurs par default
        wVal = getProperty(aVarList, 'sys_Dockproperties');
        if (wVal === undefined) {
            wVal = getProperty(aVarList, 'sys_InvoiceValidator');
        }
        if (wVal !== undefined) {
            wxmlDoc = wParser.parseFromString(wVal, 'text/xml');
            this.enableDeadline = wxmlDoc.getElementsByTagName('enabledeadline')[0].childNodes[0].nodeValue;
        }

        wVal = getProperty(aVarList, 'sys_validator');
        this.defValue = this.setDefined(wVal);

        wVal = getProperty(aVarList, 'sys_controller');
        this.defValueSto = this.setDefined(wVal);

        wVal = getProperty(aVarList, 'sys_indexer');
        this.defValueInd = this.setDefined(wVal);

        wVal = getProperty(aVarList, '__ValidationDate');
        this.datVal = this.setDefined(wVal);

        wVal = getProperty(aVarList, '__DeadLine');
        this.deadline = this.setDefined(wVal);
    }

    private setInvoiceFinal(aBskName) {
        let wParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        let wParam: any;
        let wComboValue: any;
        let wResult: any;
        let wValue: any;
        let wValidatorBasket: any;
        let wEditorName: any;
        let wCombo_value = {
            comboValue: [],
            value: '',
        };
        wParam = new Array();
        wComboValue = new Array();

        // Bannette de paiement
        // Indexeur, Valideur, Date de validation, Controller, Date limite
        // Combo indexeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceStdIndexers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueInd, wComboValue, 'retCode');
        // Ajpout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueInd, wCombo_value);
        this.setParam(
            wParam,
            'sys_indexer',
            'Indexeurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueInd,
            wCombo_value.value,
            true,
            true
        );

        // Combo valideurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupValidators');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceValidators');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValue, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValue, wCombo_value);
        this.setParam(
            wParam,
            'sys_validator',
            'Valideurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValue,
            wCombo_value.value,
            true,
            true
        );

        // Date de validation
        this.addDate(
            wParam,
            '__ValidationDate',
            'Date de validation',
            'DateTime',
            this.datVal,
            this.enableDeadline,
            false
        );

        // Combo payeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);

        wEditorName = '';
        wValidatorBasket = this.getEditorName(aBskName, 'IIA_InvoiceFinal');
        wEditorName = this.searchEditorName(
            wEditorName,
            'EDT_InvoiceGroupController_',
            'EDT_InvoiceController_',
            wValidatorBasket
        );

        if (wEditorName !== '') {
            wResult = this.editorService.getOptionComboValueData(wEditorName);
            wComboValue = this.updateComboValue(wComboValue, wResult.data);
        }
        wValue = this.editorService.getComboValueKey(this.defValueSto, wComboValue, 'retCode');
        // Ajpout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueSto, wCombo_value);
        this.setParam(
            wParam,
            'sys_controller',
            'Payeur',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueSto,
            wCombo_value.value,
            true,
            true
        );

        // Date de limite
        this.addDate(wParam, '__Deadline', 'Date limite', 'DateTime', this.deadline, this.enableDeadline, false);
        wParamDock.varList = JSON.parse(JSON.stringify(wParam));
        return wParamDock;
    }

    private setInvoiceDispute(aBskName) {
        let wParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        let wParam: any;
        let wComboValue: any;
        let wResult: any;
        let wValue: any;
        let wValidatorBasket: any;
        let wEditorName: any;
        let wCombo_value = {
            comboValue: [],
            value: '',
        };
        wParam = new Array();
        wComboValue = new Array();

        // Bannette de litige
        // Indexeur, Valideur, Date de validation, Controller, Date limite

        // Combo indexeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceStdIndexers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueInd, wComboValue, 'retCode');
        // Ajpout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueInd, wCombo_value);
        this.setParam(
            wParam,
            'sys_indexer',
            'Indexeurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueInd,
            wCombo_value.value,
            true,
            true
        );

        // Combo valideurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupValidators');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wEditorName = 'EDT_InvoiceValidators';
        wValidatorBasket = this.getEditorName(aBskName, 'IIA_InvoiceDispute_');

        wEditorName = this.searchEditorName(
            wEditorName,
            'EDT_InvoiceGroupValidator_',
            'EDT_InvoiceValidator_',
            wValidatorBasket
        );
        wResult = this.editorService.getOptionComboValueData(wEditorName);
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValue, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValue, wCombo_value);
        this.setParam(
            wParam,
            'sys_validator',
            'Valideurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValue,
            wCombo_value.value,
            true,
            true
        );

        // Date de validation
        this.addDate(
            wParam,
            '__ValidationDate',
            'Date de validation',
            'DateTime',
            this.datVal,
            this.enableDeadline,
            false
        );

        // Combo payeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);

        wEditorName = '';
        wValidatorBasket = this.getEditorName(aBskName, 'IIA_InvoiceDispute_');
        wEditorName = this.searchEditorName(
            wEditorName,
            'EDT_InvoiceGroupController_',
            'EDT_InvoiceController_',
            wValidatorBasket
        );

        if (wEditorName !== '') {
            wResult = this.editorService.getOptionComboValueData(wEditorName);
            wComboValue = this.updateComboValue(wComboValue, wResult.data);
        }
        wValue = this.editorService.getComboValueKey(this.defValueSto, wComboValue, 'retCode');
        // Ajpout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueSto, wCombo_value);
        this.setParam(
            wParam,
            'sys_controller',
            'Payeur',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueSto,
            wCombo_value.value,
            true,
            true
        );

        // Date de limite
        this.addDate(wParam, '__DeadLine', 'Date limite', 'DateTime', this.deadline, this.enableDeadline, false);

        wParamDock.varList = JSON.parse(JSON.stringify(wParam));
        return wParamDock;
    }

    private setInvoiceValidation(aBskName) {
        let wParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        let wParam: any;
        let wComboValue: any;
        let wResult: any;
        let wValue: any;
        let wValidatorBasket: any;
        let wEditorName: any;
        let wCombo_value = {
            comboValue: [],
            value: '',
        };
        wParam = new Array();
        wComboValue = new Array();

        // Validation des factures :
        // Indexeur, Valideur, Date de validation, Controller, Date limite

        // Combo indexeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceStdIndexers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueInd, wComboValue, 'retCode');
        // Ajpout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueInd, wCombo_value);
        this.setParam(
            wParam,
            'sys_indexer',
            'Indexeurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueInd,
            wCombo_value.value,
            true,
            true
        );

        // Combo valideurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupValidators');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wEditorName = 'EDT_InvoiceValidators';
        wValidatorBasket = this.getEditorName(aBskName, 'IIA_InvoiceValidation');
        wEditorName = this.searchEditorName(
            wEditorName,
            'EDT_InvoiceGroupValidator_',
            'EDT_InvoiceValidator_',
            wValidatorBasket
        );

        wResult = this.editorService.getOptionComboValueData(wEditorName);
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValue, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValue, wCombo_value);
        this.setParam(
            wParam,
            'sys_validator',
            'Valideurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValue,
            wCombo_value.value,
            true,
            true
        );

        // Date de validation
        this.addDate(
            wParam,
            '__ValidationDate',
            'Date de validation',
            'DateTime',
            this.datVal,
            this.enableDeadline,
            false
        );

        // Combo payeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueSto, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueSto, wCombo_value);
        this.setParam(
            wParam,
            'sys_controller',
            'Payeur',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueSto,
            wCombo_value.value,
            true,
            true
        );

        // Date de limite
        this.addDate(wParam, '__DeadLine', 'Date limite', 'DateTime', this.deadline, this.enableDeadline, false);

        wParamDock.varList = JSON.parse(JSON.stringify(wParam));
        return wParamDock;
    }

    private setInvoiceIndexing() {
        let wParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        let wParam: any;
        let wComboValue: any;
        let wResult: any;
        let wValue: any;
        let wValueSvg: any;
        let wCombo_value = {
            comboValue: [],
            value: '',
        };
        wParam = new Array();
        wComboValue = new Array();

        // Indexation des factures :
        // Indexeur, Valideur, Date de validation, Controller, Date limite

        // Combo indexeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceStdIndexers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        // Récupération de la valeur par defaut _StandardIndexers_
        wValueSvg = this.editorService.getComboValueKey('_StandardIndexers_', wComboValue, 'retCode');
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceIndexers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueInd, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueInd, wCombo_value);
        // Affectation de la valeur par défaut
        if (this.defValueInd === '') {
            this.defValueInd = '_StandardIndexers_';
            wCombo_value.value = wValueSvg;
        }
        this.setParam(
            wParam,
            'sys_indexer',
            'Indexeurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueInd,
            wCombo_value.value,
            true,
            true
        );

        // Combo valideurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupValidators');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceValidators');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValue, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValue, wCombo_value);
        this.setParam(
            wParam,
            'sys_validator',
            'Valideurs',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValue,
            wCombo_value.value,
            true,
            true
        );

        // Date de validation
        this.addDate(
            wParam,
            '__ValidationDate',
            'Date de validation',
            'DateTime',
            this.datVal,
            this.enableDeadline,
            false
        );

        // Combo payeurs
        wComboValue = [];
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        // Récupération de la valeur par défaut _StandardControllers_
        wValueSvg = this.editorService.getComboValueKey('_StandardControllers_', wComboValue, 'retCode');
        wResult = this.editorService.getOptionComboValueData('EDT_InvoiceGroupControllers');
        wComboValue = this.updateComboValue(wComboValue, wResult.data);
        wValue = this.editorService.getComboValueKey(this.defValueSto, wComboValue, 'retCode');
        // Ajout d'une entrée dans la liste déroulante en cas de retour dans le flux Facture
        wCombo_value = {
            comboValue: wComboValue,
            value: wValue,
        };
        wCombo_value = this.addToList(this.defValueSto, wCombo_value);
        // Affectation de la valeur par défaut
        if (this.defValueSto === '') {
            this.defValueSto = '_StandardControllers_';
            wCombo_value.value = wValueSvg;
        }
        this.setParam(
            wParam,
            'sys_controller',
            'Payeur',
            'ComboCustom',
            wCombo_value.comboValue,
            this.defValueSto,
            wCombo_value.value,
            true,
            true
        );

        // Date de limite
        this.addDate(wParam, '__DeadLine', 'Date limite', 'DateTime', this.deadline, this.enableDeadline, false);

        wParamDock.varList = JSON.parse(JSON.stringify(wParam));
        return wParamDock;
    }

    private searchEditorName(aEditorBase, aEditorGrp, aEditor, aValidatorBasket) {
        let wEditorName = aEditorBase;
        if (this.editorService.editorExist(aEditorGrp + aValidatorBasket)) {
            wEditorName = aEditorGrp + aValidatorBasket;
        } else {
            if (this.editorService.editorExist(aEditor + aValidatorBasket)) {
                wEditorName = aEditor + aValidatorBasket;
            }
        }
        return wEditorName;
    }

    private addToList(aDefValue, aCombo_value) {
        let wCombo_value = {
            comboValue: [],
            value: '',
        };
        if (aDefValue !== '' && aCombo_value.value.retCode === '') {
            wCombo_value.comboValue = this.addToCombo(aCombo_value.comboValue, aDefValue);
            wCombo_value.value = this.editorService.getComboValueKey(aDefValue, aCombo_value.comboValue, 'retCode').retCode;
        } else {
            wCombo_value = aCombo_value;
        }
        return wCombo_value;
    }

    private addToCombo(aComboValue, aValue) {
        let wResult: any;
        wResult = this.editorService.getValue(this.edtAllUser.data, aValue);
        if (wResult !== null && wResult !== undefined) {
            return this.editorService.addToComboValue(aComboValue, wResult);
        } else {
            return aComboValue;
        }
    }

    private addDate(aParam, aFieldName, aLabel, aFieldType, aDate, aEnableDeadline, aRequired) {
        let wDate: Date;
        let wDateFormat = '';
        if (aDate !== '') {
            wDate = new Date(aDate);
            wDateFormat = formatDateTimeInternal(wDate);
        } else {
            wDate = null;
        }
        this.setParam(
            aParam,
            aFieldName,
            aLabel,
            aFieldType,
            [],
            wDateFormat,
            wDate,
            !checkBoolean(aEnableDeadline),
            aRequired
        );
    }

    private setParam(aParam, aName, aLabel, aType, aComboValue, aDefVal, aValue, aEnable, aRequired) {
        let wParam = {
            name: aName,
            Label: aLabel,
            type: aType,
            DefaultValue: aDefVal,
            comboValue: aComboValue,
            Required: aRequired,
            system: false,
            Editable: false,
            value: aValue,
            visible: 1,
            pattern: '',
            disabled: aEnable,
        };
        aParam.push(wParam);
    }

    private setDefined(aValue) {
        if (aValue !== undefined) {
            return aValue;
        }
        return '';
    }

    private getEditorName(aBskName, aCheckValue) {
        let wLength = 0;
        wLength = (aBskName.length - 1 - aCheckValue.length) * -1;
        return aBskName.slice(wLength);
    }

    private getTypeBskDock(aBskName: string) {
        if (aBskName.indexOf('IIA_InvoiceIndexing') === 0) {
            return 'IIA_InvoiceIndexing';
        }
        if (aBskName.indexOf('IIA_InvoiceValidation') === 0) {
            return 'IIA_InvoiceValidation';
        }
        if (aBskName.indexOf('IIA_InvoiceDispute') === 0) {
            return 'IIA_InvoiceDispute';
        }
        if (aBskName.indexOf('IIA_InvoiceFinal') === 0) {
            return 'IIA_InvoiceFinal';
        }
        return 'IIA_InvoiceValidation';
    }
}
